module.exports = __webpack_public_path__ + "media/newstyle/images/a5-white-84ab98840be2e2fde9bf7f171b07b99b.svg";